import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.nginx = bracketIndenting({
	line: "#",
})
